import LimitedVisibilityNode from './LimitedVisibility';
import { NodeProps } from '../types';
export default function NoLoopNode(props: NodeProps) {
	return <LimitedVisibilityNode {...props} type="branches" />;
}
